module.exports = __webpack_public_path__ + "static/media/fold.fbb13985.svg";